import React, { useRef, useEffect } from 'react';

const VideoPlayer: React.FC<{ videoUrl: string }> = ({ videoUrl }) => {
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    const videoElement = videoRef.current;

    const handlePlay = () => {
      videoElement?.play();
    };

    videoElement?.addEventListener('click', handlePlay);

    return () => {
      videoElement?.removeEventListener('click', handlePlay);
    };
  }, []);

  return (
    <div className="video-container">
      <div className="video-wrapper">
        <video
          key={videoUrl}
          ref={videoRef}
          src={videoUrl}
          controls
          controlsList="nodownload"
          onContextMenu={(e) => e.preventDefault()}
          className="rounded-video w-full h-auto"
        />
      </div>
    </div>
  );
};

export default VideoPlayer;